module.exports = __webpack_public_path__ + "img/infinity6.152c7d14.jpg";